import React from "react";
import styles from "./developers.module.scss";
export default function Intro() {
  return (
    <div className="col-12 col-md-6 offset-md-3">
      {" "}
      <h2 className="text-center">
        Headlockr 5 fits right into <br className="d-none d-lg-block" /> your existing{" "}
        <span className="text-tertiary">Strapi</span> setup
      </h2>
      <p className={`text-center py-2 ${styles.paragraph}`}>
        Install the package, add your license, configure the plugin, and ship.
        Headlockr 5 no longer requires custom Vite or Webpack wiring for the Strapi admin panel.
      </p>
    </div>
  );
}
